const DNI_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE' as const;

/**
 * Validates Spanish NIF (DNI or NIE)
 * @param nif - The NIF string to validate (can be DNI or NIE)
 * @returns true if valid, false otherwise
 */
export const validateNIF = (nif: string): boolean => {
  const cleanNIF = nif.toUpperCase().replace(/[\s-]/g, '');

  // Regex for DNI (8 digits + letter)
  if (/^[0-9]{8}[A-Z]$/.test(cleanNIF)) {
    return validateDNI(cleanNIF);
  }

  // Regex for NIE (X/Y/Z + 7 digits + letter)
  if (/^[XYZ][0-9]{7}[A-Z]$/.test(cleanNIF)) {
    return validateNIE(cleanNIF);
  }

  return false;
};

const validateDNI = (dni: string): boolean => {
  const number = parseInt(dni.substring(0, 8), 10);
  const calculatedLetter = DNI_LETTERS[number % 23];
  const providedLetter = dni.charAt(8);

  return calculatedLetter === providedLetter;
};

const validateNIE = (nie: string): boolean => {
  const numericNIE = nie.replace('X', '0').replace('Y', '1').replace('Z', '2');

  const number = parseInt(numericNIE.substring(0, 8), 10);
  const calculatedLetter = DNI_LETTERS[number % 23];
  const providedLetter = nie.charAt(8);

  return calculatedLetter === providedLetter;
};
